import axios from "axios";
import { getValidToken } from "../../../utils/authUtils";
import { RouteType, StopType } from "./types";

const routeApi = {
  getAllRoutes: async () => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}master-data/routes`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error fetching routes:", error);
      return [];
    }
  },

  createRoute: async (routeData: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}master-data/routes`;
      const token = await getValidToken();
      const response = await axios.post(url, routeData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error creating route:", error);
      throw error;
    }
  },

  updateRoute: async (routeId: string, routeData: Partial<RouteType>) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}master-data/routes/${routeId}`;
      const token = await getValidToken();
      const response = await axios.put(url, routeData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error updating route:", error);
      throw error;
    }
  },

  createStops: async (stops: StopType[]) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}master-data/stops`;
      const token = await getValidToken();
      const response = await axios.post(url, stops, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error updating stops:", error);
      throw error;
    }
  },

  updateStops: async (stops: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}master-data/stops`;
      const token = await getValidToken();
      const response = await axios.put(url, stops, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error updating stops:", error);
      throw error;
    }
  },

  deleteStops: async (stops: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}master-data/stops/delete`;
      const token = await getValidToken();
      const response = await axios.post(url, stops, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error updating stops:", error);
      throw error;
    }
  },
};

export default routeApi;

export const routeServiceApi = {
  createRoute: async (routeData: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}routes`;
      const token = await getValidToken();
      const response = await axios.post(url, routeData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error creating route:", error);
      throw error;
    }
  },

  updateRoute: async (routeId: string, routeData: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}routes/${routeId}`;
      const token = await getValidToken();
      const response = await axios.put(url, routeData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error creating route:", error);
      throw error;
    }
  },

  getRouteById: async (routeId: string) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}routes/${routeId}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error fetching route by id:", error);
      throw error;
    }
  },

  getAllCompanyRoutes: async () => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}routes/company`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error fetching routes:", error);
      return [];
    }
  },

  updateSchedule: async (scheduleId: string, scheduleData: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}routes/schedules/${scheduleId}`;
      const token = await getValidToken();
      const response = await axios.put(url, scheduleData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return true;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error updating schedule:", error);
      throw error;
    }
  },

  createSchedule: async (routeId: string, scheduleData: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}routes/${routeId}/schedules`;
      const token = await getValidToken();
      const response = await axios.post(url, scheduleData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      console.error("Error creating schedule:", error);
      throw error;
    }
  },

  getAllUniqueStops: async () => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}routes/stops/unique/by-company`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        throw new Error(response.data?.message);
      }
    } catch (error) {
      return [];
    }
  },
};
